import { defineStore as c } from "pinia";
import { signOut as u } from "aws-amplify/auth";
import s from "lodash/has";
import f from "lodash/find";
import { useAbility as h } from "@casl/vue";
import { PermissionConstants as m } from "@switchsystems/coactive-node-lib-permissions";
import { g as i } from "../lib/deviceNotificationToken.V6Sa4Pxk.js";
const o = "users", r = "/v1", a = ["chat"], A = c("auth", {
  state: () => ({
    hasCheckedUser: !1,
    user: {},
    navUserDropdownAppBadgeCounts: {}
  }),
  getters: {
    roles: (t) => t.user.roles ?? [],
    ability: (t) => t.user.ability ?? {},
    isAgencyUser: (t) => s(t.user, "agencyId"),
    isSignedIn: (t) => s(t.user, "id"),
    canAccessApp: () => (t) => {
      if (t === "recruitment")
        return !0;
      const e = f(m.apps, { id: t });
      return e === void 0 ? !1 : h().can(e.abilityAction, e.abilitySubject);
    }
  },
  actions: {
    /**
     * Load attributes of the authenticated user
     */
    async loadUser() {
      try {
        this.user = await this.$api.doNotCatchIfError().get(o, `${r}/users/me`);
      } catch {
        this.$reset();
      }
    },
    /**
     * Heartbeat ping to log that user is active
     */
    async userPing() {
      return this.$api.doNotCatchIfError().post(o, `${r}/users/me/ping`);
    },
    /**
     * Synchronise the logged in user's messaging channel list
     */
    async subscribeToMessagingChannels() {
      return this.$api.doNotCatchIfError().post(
        o,
        `${r}/users/me/subscribe-to-messaging-channels`
      );
    },
    /**
     * Recalculate the notification badge counts for the user
     */
    async refreshAppBadgeCounts() {
      await this.getUnreadAnnouncements();
    },
    /**
     * Get unread announcement messages for the logged in user
     *
     * @param {number} page - The page number to retrieve
     */
    async getUnreadAnnouncements(t) {
      const e = await this.$api.doNotCatchIfError().get(o, `${r}/users/me/announcements/unread`, {
        queryStringParameters: {
          page: t || 1
        }
      });
      return e && e.total && (this.navUserDropdownAppBadgeCounts.chat = e.total), e;
    },
    /**
     * Mark a specific announcement message as read
     */
    async markAnnouncementAsRead(t) {
      return this.$api.post(
        o,
        `${r}/users/me/announcements/${t}/mark-read`
      );
    },
    /**
     * Logs the sign out event
     * @returns {Promise}
     */
    async logUserSignOut() {
      return this.$api.doNotCatchIfError().post(o, `${r}/log/logout`);
    },
    /**
     * Actions to perform on a user sign in
     */
    async onSignIn() {
      await this.loadUser(), await this.registerNotificationTokens();
    },
    /**
     * Actions to perform on a user sign out
     */
    async onSignOut() {
      try {
        await this.removeNotificationTokens(), await this.logUserSignOut();
      } catch (t) {
        console.warn("Failed logUserSignOut", t);
      }
      await u({ global: !0 }), this.$reset();
    },
    /**
     * Registers a notification token for a specific app ID.
     *
     * @param {string} appId - The ID of the app.
     * @returns {Promise<void>}
     */
    async registerNotificationToken(t) {
      const e = i(t);
      if (e) {
        try {
          return await this.$api.doNotCatchIfError().put(
            o,
            `${r}/users/me/notification-token/${t}`,
            { body: { tokenId: e } }
          );
        } catch (n) {
          console.warn("Failed to register notification token", n);
        }
        return !1;
      }
    },
    /**
     * De-associates (in Mongo) the device token for the specified app ID from the user logging out.
     *
     * @param {string} appId - The ID of the app.
     * @returns {Promise<void>}
     */
    async removeNotificationToken(t) {
      const e = i(t);
      if (e)
        try {
          return await this.$api.doNotCatchIfError().post(o, `${r}/users/notification-token/delete`, {
            body: { tokenId: e }
          });
        } catch (n) {
          console.warn("Failed to remove notification token", n);
        }
    },
    /**
     * Registers all notification tokens for the user.
     */
    async registerNotificationTokens() {
      const t = [];
      for (const e of a)
        t.push(this.registerNotificationToken(e));
      return Promise.all(t);
    },
    /**
     * Removes all notification tokens for the user.
     */
    async removeNotificationTokens() {
      const t = [];
      for (const e of a)
        t.push(this.removeNotificationToken(e));
      return Promise.all(t);
    }
  }
});
export {
  A as u
};
